module.exports = __webpack_public_path__ + "static/media/obj-2.4a9da72e.svg";